export const gameConstants = {
  UPDATE_SPORTS_DATA: "UPDATE_SPORTS_DATA",
  UPDATE_GAMES_DATA: "UPDATE_GAMES_DATA",
  UPDATE_LOADING: "UPDATE_LOADING",
  UPDATE_LIVE_GAME: "UPDATE_LIVE_GAME",
  UPDATE_LIVE_GAME_PROVIDERS: "UPDATE_LIVE_GAME_PROVIDERS",

};
